import { Component } from '@angular/core';
@Component({
  selector: 'app-access-denied',
  standalone: true,
  template: `
    <div class="access-denied">
      <h1>Access Denied</h1>
      <p>This application must be opened through the ARRK DX platform.</p>
    </div>
  `,
  styles: [`
    .access-denied {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      font-family: sans-serif;
      color: #444;
      text-align: center;
      gap: 1rem;
    }
    h1 { margin: 0; font-size: 2rem; }
    p  { margin: 0; font-size: 1rem; color: #666; }
  `]
})
export class AccessDeniedComponent {}
